import React from "react";
import EventRow from "./EventRow";
import ThumbUpAltRoundedIcon from "@material-ui/icons/ThumbUpAltRounded";
import { Button } from "@material-ui/core";

const CandidateEvents = (props) => {
  const [eventsRendering, setEventsRendering] = React.useState([]);

  React.useEffect(() => {
    let localEvents = [];
    localEvents =
      props.filterByType && props.filterByType !== ""
        ? props.candidateData.filter(
            (event) => event.event.event_key === props.filterByType
          )
        : props.candidateData;
    if (props.jobId && props.showCurrentJobOnly) {
      localEvents = localEvents.filter(
        (event) =>
          parseInt(event.event.job_id) === props.jobId ||
          ((event.event.event_key === "link_to_job" ||
            event.event.event_key === "removeFromJob") &&
            parseInt(event.event.event_value) === props.jobId)
      );
    }
    if (
      props.filter &&
      props.filter.filterByDate &&
      props.filter.filterByDate !== ""
    ) {
      switch (props.filter.filterByDate) {
        case "lastSevenDays": {
          const sevenDays = new Date(
            new Date().setDate(new Date().getDate() - 7)
          );
          localEvents = localEvents.filter(
            (event) => new Date(event.event.event_date) >= sevenDays
          );
          break;
        }
        case "lastFourteenDays": {
          const sevenDays = new Date(
            new Date().setDate(new Date().getDate() - 14)
          );
          localEvents = localEvents.filter(
            (event) => new Date(event.event.event_date) >= sevenDays
          );
          break;
        }
        case "thisMonth": {
          const firstDay = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          );
          localEvents = localEvents.filter(
            (event) => new Date(event.event.event_date) >= firstDay
          );
          break;
        }
        case "lastMonth": {
          const firstDay = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            1
          );
          const lastDay = new Date(
            firstDay.getFullYear(),
            firstDay.getMonth() + 1,
            0
          );
          localEvents = localEvents.filter(
            (event) =>
              new Date(event.event.event_date) >= firstDay &&
              new Date(event.event.event_date) <= lastDay
          );
          break;
        }
        case "thisYear": {
          const currentYear = new Date(new Date().getFullYear(), 1, 1);
          localEvents = localEvents.filter(
            (event) => new Date(event.event.event_date) >= currentYear
          );
          break;
        }

        default: {
          //localEvents = [];
        }
      }
    }

    setEventsRendering(localEvents);
  }, [
    props.candidateData,
    props.showCurrentJobOnly,
    props.filterByType,
    props.jobId,
    props.filter,
  ]);
  const events = eventsRendering
    .sort((a, b) => new Date(b.event.event_date) - new Date(a.event.event_date))
    .map((event) => {
      //End case scenario: the event id might not be unique because the data is retrieved from two different tables.
      switch (event.event.event_key) {
        case "job_mail_sent":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventTitle="Candidate invited to job"
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "link_to_job":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventTitle="Candidate linked to job"
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "removeFromJob":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventTitle="Candidate removed from job"
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "unsubscribeRequest":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventType="unsubscribeRequest"
              eventTitle={`Candidate added to unsubscribe list. Unsubscribe reason: ${event.event.event_value}.`}
              authorImage={event.author_image}
              event={event.event}
              authorName={event.author_name}
            />
          );
        case "addComment":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventType="addComment"
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "cvReferrals":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventTitle={`Candidate CVs has been sent to customer. Job ID: ${event.event.event_value}`}
              eventType="cvReferrals"
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "addRating":
          return (
            <EventRow
              key={event.event.event_key + "_" + event.event.id}
              eventType="addRating"
              eventTitle="Add candidate rating"
              authorImage={event.author_image}
              event={event.event}
              authorName={event.author_name}
            />
          );

        case "candidate_declined_job":
          let rejectionReason = "";
          switch (event.event.event_value) {
            case "employed":
              rejectionReason = "Already Employed";
              break;
            case "salary":
              rejectionReason = "Offered Salary";
              break;
            case "location":
              rejectionReason = "Job Location";
              break;
            case "jobRequirements":
              rejectionReason = "Job Requirements";
              break;
            case "other":
              rejectionReason = `Other ${
                event.event.event_comment
                  ? ": " + event.event.event_comment
                  : ""
              }`;
              break;
            default:
              break;
          }
          return (
            <EventRow
              key={event.event.id}
              eventType="candidate_declined_job"
              eventTitle={`Candidate rejected job id ${event.event.job_id}. Rejection reason: ${rejectionReason}`}
              jobTitle={event.job_title}
              authorImage={event.author_image}
              event={event.event}
              authorName={event.author_name}
            />
          );
        case "addPhoneInterview":
          return (
            <EventRow
              key={event.event.id}
              eventType="addPhoneInterview"
              eventTitle={`Phone interview conducted for job id ${event.event.job_id}. `}
              authorImage={event.author_image}
              jobTitle={event.job_title}
              event={event.event}
              authorName={event.author_name}
              onAddEvent={props.onAddEvent}
            />
          );
        case "advancedRecruitmentProcedures":
          return (
            <EventRow
              key={event.event.id}
              eventType="advancedRecruitmentProcedures"
              eventTitle={`Candidate moved to advanced recruitment procedures in job id ${event.event.job_id}. `}
              authorImage={event.author_image}
              jobTitle={event.job_title}
              event={event.event}
              authorName={event.author_name}
              onAddEvent={props.onAddEvent}
            />
          );
        case "companySendToInterview":
          return (
            <EventRow
              key={event.event.id}
              eventType="companySendToInterview"
              eventTitle={`Candidate invited for job interview at company id ${event.event.event_value} `}
              authorImage={event.author_image}
              event={event.event}
              authorName={event.author_name}
              interview={event.interview ? event.interview : ""}
              onAddEvent={props.onAddEvent}
            />
          );
        case "sendToInterview":
          return (
            <EventRow
              key={event.event.id}
              eventType="sendToInterview"
              eventTitle={`Candidate invited for job interview in job id ${event.event.event_value} `}
              authorImage={event.author_image}
              jobTitle={event.job_title}
              event={event.event}
              authorName={event.author_name}
              interview={event.interview ? event.interview : ""}
              onAddEvent={props.onAddEvent}
            />
          );
        case "candidate_accepted_job":
          let title = "";
          if (event.event.event_value === "failed")
            title = `Candidate intersted in job id ${event.event.job_id}, but automatically disqualified`;
          else if (event.event.event_value === "partial")
            title = `Candidate intersted in job id ${event.event.job_id}, and partially passed`;
          else
            title = `Candidate intersted in job id ${event.event.job_id}, and succesfully passed`;
          return (
            <EventRow
              key={event.event.id}
              eventType="candidate_accepted_job"
              jobTitle={event.job_title}
              eventTitle={title}
              authorImage={event.author_image}
              event={event.event}
              authorName={event.author_name}
            />
          );
        case "sendInvitation":
          return (
            <EventRow
              key={event.event.id}
              eventType="sendInvitation"
              eventTitle={`Candidate has been invited for job id ${event.event.event_value}`}
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "candidate_watched_job":
          return (
            <EventRow
              key={event.event.id}
              eventType="candidate_watched_job"
              eventTitle={`Candidate watched in job id ${event.event.job_id}`}
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
            />
          );
        case "recruitmentSucceeded":
          return (
            <EventRow
              key={event.event.id}
              eventType="recruitmentSucceeded"
              eventTitle={`Candidate successfully recruited for job id ${event.event.job_id}`}
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
              endIcon={<ThumbUpAltRoundedIcon />}
            />
          );
        case "companyRecruitmentSucceeded":
          return (
            <EventRow
              key={event.event.id}
              eventType="companyRecruitmentSucceeded"
              eventTitle={`Candidate successfully recruited to company id ${event.event.company_id}`}
              authorImage={event.author_image}
              event={event.event}
              jobTitle={event.job_title}
              authorName={event.author_name}
              endIcon={<ThumbUpAltRoundedIcon />}
            />
          );
        default:
          return null;
      }
    });

  return (
    <React.Fragment>
      {events}
      <div>
        <Button
          variant="outlined"
          color="primary"
          onClick={props.eventsOffset ? props.eventsOffset : null}
          style={{ marginTop: 16 }}
          disabled={parseInt(props.totalEvents) === eventsRendering.length}
        >
          More events
        </Button>
      </div>
    </React.Fragment>
  );
};
export default CandidateEvents;
